/** Query keys for the calls table, scoped by campaign, entity and contact. */
export const callKeys = {
  all: ["calls"],
  lists: () => [...callKeys.all, "list"],
  list: ({ campaignId = null, entityId = null, contactId = null } = {}) => [
    ...callKeys.lists(),
    { campaignId, entityId, contactId },
  ],
};
